module.exports = __webpack_public_path__ + "assets/img/guohui.d0289dc0.png";